import React, { Component } from 'react';
import { array } from 'prop-types';

import API from '../../../api';
import { promiseLoader } from '../../../components/common/promise-loader';
import ClientsList from '../../../components/staff/clients-list';

class ClientsIndex extends Component {
  static propTypes = {
    clients: array
  };

  render () {
    const { clients } = this.props;
    return <ClientsList clients={clients} />;
  }
}

export default promiseLoader(
  () => API.staff.getClients(),
  'clients'
)(ClientsIndex);
